<style>
.edi-passwordmodify {
	height: 100%;
	background-color: #eee;
}
.edi-passwordmodify .fieldset-1 {
	margin-top: 3em !important;
}
.ui-content .ui-listview-inset {
	margin: 1em 0;
	-webkit-border-radius: .3125em;
	border-radius: .3125em;
}
.ui-btn {
	cursor: pointer;
	padding: .3em .8em;
	margin-right: .3em;
}
</style>

<template>
	<div class="edi-passwordmodify">
		<navbar title="修改密码"></navbar>
		<form class="ui-content" @submit.prevent="onCheckSubmit">
			<ul class="ui-listview ui-listview-inset">
				<li class="ui-listview-first-item"><input type="password" v-model="newPassword" placeholder="请输入新密码"/></li>
				<li class=""><input type="password" v-model="newPasswordConfirm" placeholder="请确认新密码"/></li>
				<li style="display: flex;border-top: 1px #ddd solid;border-radius: 0 0 .3125em .3125em">
					<input type="text" name="verifyCode" v-model="verifyCode" placeholder="图形验证码" />
					<img :src="verifyCodeImg" @click="refreshVerifyCodeClick" style="height: 36px" />
				</li>
				<li class="ui-listview-last-item">
					<div class="ui-col-6"><input type="text" placeholder="验证码" v-model="vCode"/></div
						><div class="ui-col-4 ui-align-right"><mobile-code :type="2" :mobile="telephone" :verifyCode="verifyCode" :uuid="verifyUUID" @on-refresh="refreshVerifyCodeClick"></mobile-code></div>
				</li>
			</ul>
			<fieldset class="ui-controlgroup">
				<input type="submit" value="确认修改" class="submit"/>
			</fieldset>
		</form>
		<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
	</div>
</template>

<script>
import MobileCode from '../components/MobileCode'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import NavBar from '../components/NavBar'

export default {
	data () {
		return {
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			telephone: this.$route.query.telephone,
			newPassword: '',
			newPasswordConfirm: '',
			vCode: '',
			codePatrn: /^\d{4}$/,
			sec: 1500,
			verifyUUID: this.$fxUtils.createUUID(),
			verifyCode: ''
		}
	},
	components: {
		'mobile-code': MobileCode,
		'tips': Tips,
		'tips-auto': TipsAuto,
		'navbar': NavBar
	},
	computed: {
		verifyCodeImg () {
			return `/cldEdi/business/${this.verifyUUID}/getVerifyCode`
		}
	},
	methods: {
		refreshVerifyCodeClick () {
			this.verifyUUID = this.$fxUtils.createUUID()
		},
		tipStatus (msg) {
			this.tips = msg[0]
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		delaySkip (path) {
			var self = this
			setTimeout(() => {
				this.$router.push({path: path})
			}, self.sec)
		},
		onCheckSubmit () {
			if (this.newPassword === '') {
				this.autoTips('请输入密码')
				return false
			}
			if (this.newPasswordConfirm === '') {
				this.autoTips('请确认密码')
				return false
			} else if (this.newPasswordConfirm !== this.newPassword) {
				this.autoTips('两次填写密码不一致')
				return false
			}
			if (this.vCode === '') {
				this.autoTips('验证码不能为空')
				return false
			} else if (!(this.codePatrn.test(this.vCode))) {
				this.autoTips('验证码为四位数字')
				return false
			}
			if (this.verifyCode === '') {
				this.autoTips('图形验证码不能为空')
				return false
			}
			this.modifyPost()
		},
		modifyPost () {
			var obj = {
				newPassword: this.newPassword,
				newPasswordConfirm: this.newPasswordConfirm,
				vCode: this.vCode
			}
			this.$http.post('/cldEdi/business/modifyPass', obj).then((response) => {
				var data = response.body
				if (!data.result) {
					this.autoTips(data.message)
					return false
				} else {
					this.autoTips('修改密码成功')
					this.delaySkip('/accounts')
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// PasswordModifyM.vue?5b7958c2